module.exports = __webpack_public_path__ + "static/media/machineLarge.455ab533.svg";